/**
 * WordPress dependencies
 */
import { createContext } from '@wordpress/element';
/**
 * Internal dependencies
 */

const initialContextValue = {
  location: {},
  goTo: () => {},
  goBack: () => {}
};
export const NavigatorContext = createContext(initialContextValue);
//# sourceMappingURL=context.js.map